import createIcon from '../../createIcon';

/**
 * @component @name SportsVolleyball
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4wMzUxNiAzLjk4NTM5QzMuNjE1MTYgNS44MTUzOSAyLjAzNTE2IDguNzA1MzkgMi4wMzUxNiAxMS45NzU0QzIuMDM1MTYgMTMuNDM1NCAyLjM1NTE2IDE0LjgyNTQgMi45MjUxNiAxNi4wODU0TDYuMDM1MTYgMTQuMjg1NFYzLjk4NTM5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjAzNTIgMTEuMzk1NFYyLjAyNTM5QzkuOTc1MTYgMi4xMzUzOSA4Ljk2NTE2IDIuNDA1MzkgOC4wMzUxNiAyLjgxNTM5VjEzLjEzNTRMMTEuMDM1MiAxMS4zOTU0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyLjAzNTIgMTMuMTI1NEwzLjkyNTE2IDE3LjgwNTRDNC41MzUxNiAxOC42NDU0IDUuMjY1MTYgMTkuMzk1NCA2LjEwNTE2IDIwLjAwNTRMMTUuMDM1MiAxNC44NjU0TDEyLjAzNTIgMTMuMTI1NFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMy4wMzUyIDcuOTM1MzlWMTEuMzk1NEwyMS4xNDUyIDE2LjA3NTRDMjEuNTY1MiAxNS4xNDU0IDIxLjg0NTIgMTQuMTQ1NCAyMS45NjUyIDEzLjA5NTRMMTMuMDM1MiA3LjkzNTM5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTguMTA1MTYgMjEuMTc1NEM5LjMxNTE2IDIxLjY4NTQgMTAuNjM1MiAyMS45NzU0IDEyLjAzNTIgMjEuOTc1NEMxNS4zNzUyIDIxLjk3NTQgMTguMzI1MiAyMC4zMjU0IDIwLjE0NTIgMTcuODE1NEwxNy4wMzUyIDE2LjAxNTRMOC4xMDUxNiAyMS4xNzU0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxLjk1NTIgMTAuNzg1NEMyMS40MDUyIDYuMTU1MzkgMTcuNjk1MiAyLjQ4NTM5IDEzLjAzNTIgMi4wMjUzOVY1LjYyNTM5TDIxLjk1NTIgMTAuNzg1NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsVolleyball = createIcon('SportsVolleyball', [
  [
    'path',
    {
      d: 'M6.03516 3.98539C3.61516 5.81539 2.03516 8.70539 2.03516 11.9754C2.03516 13.4354 2.35516 14.8254 2.92516 16.0854L6.03516 14.2854V3.98539Z',
      key: 'tn0j8p',
    },
  ],
  [
    'path',
    {
      d: 'M11.0352 11.3954V2.02539C9.97516 2.13539 8.96516 2.40539 8.03516 2.81539V13.1354L11.0352 11.3954Z',
      key: '1r4y8t',
    },
  ],
  [
    'path',
    {
      d: 'M12.0352 13.1254L3.92516 17.8054C4.53516 18.6454 5.26516 19.3954 6.10516 20.0054L15.0352 14.8654L12.0352 13.1254Z',
      key: '1yhxnp',
    },
  ],
  [
    'path',
    {
      d: 'M13.0352 7.93539V11.3954L21.1452 16.0754C21.5652 15.1454 21.8452 14.1454 21.9652 13.0954L13.0352 7.93539Z',
      key: '1vvz8t',
    },
  ],
  [
    'path',
    {
      d: 'M8.10516 21.1754C9.31516 21.6854 10.6352 21.9754 12.0352 21.9754C15.3752 21.9754 18.3252 20.3254 20.1452 17.8154L17.0352 16.0154L8.10516 21.1754Z',
      key: 'p9q3j3',
    },
  ],
  [
    'path',
    {
      d: 'M21.9552 10.7854C21.4052 6.15539 17.6952 2.48539 13.0352 2.02539V5.62539L21.9552 10.7854Z',
      key: '507j9d',
    },
  ],
]);

export default SportsVolleyball;
